/*=========================================================================================
  File Name: router.js
  Description: Routes for vue-router. Lazy loading is enabled.
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


import Vue from 'vue'
import Router from 'vue-router'
import store from './store/store'

Vue.use(Router)

const router = new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    scrollBehavior () {
        return { x: 0, y: 0 }
    },
    routes: [

        {
    // =============================================================================
    // MAIN LAYOUT ROUTES
    // =============================================================================
            path: '',
            component: () => import('./layouts/main/Main.vue'),
            children: [
        // =============================================================================
        // Theme Routes
        // =============================================================================
              {
                path: '/active-users',
                name: 'active-users',
                component: () => import('./views/students/active-users.vue'),
                meta: {
                  requiresAuth: true
                }
              },{
                path: '/',
                name: 'home',
                component: () => import('./views/students/list.vue'),
                meta: {
                  requiresAuth: true
                }
              },
              {
                path: '/level',
                name: 'level',
                component: () => import('./views/levels/list.vue'),
                meta: {
                  requiresAuth: true
                }
              },
              {
                path: '/topic',
                name: 'topic',
                component: () => import('./views/topic/list.vue'),
                meta: {
                  requiresAuth: true
                }
              },
              {
                path: "/paragraph",
                name: "المقالات",
                component: () => import('./views/paragraph/list.vue'),
                meta: {
                  requiresAuth: true
                }
              },
              {
                path: "/paragraph/add",
                name: "المقالات",
                component: () => import('./views/paragraph/form.vue'),
                meta: {
                  requiresAuth: true
                }
              },{
                path: "/paragraph/:id/addQuestion",
                name: "الاسئلة",
                component: () => import('./views/paragraph/addQuestion.vue'),
                meta: {
                  requiresAuth: true
                }
              },{
                path: "/paragraph/:id/edit",
                name: "الاسئلة",
                component: () => import('./views/paragraph/editParagraph.vue'),
                meta: {
                  requiresAuth: true
                }
              }, {
                path: "/question/:id/editQuestion",
                name: "الاسئلة",
                component: () => import('./views/paragraph/editQuestion.vue'),
                meta: {
                  requiresAuth: true
                }
              },
              {
                path: "/paragraph/:id/showQuestions",
                name: "الاسئلة",
                component: () => import('./views/paragraph/showQuestions.vue'),
                meta: {
                  requiresAuth: true
                }
              },
              {
                path: "/student/:id/exams",
                name: "الامتحانات",
                component: () => import('./views/exam/showStudentExams.vue'),
                meta: {
                  requiresAuth: true
                }
              }

              
            ],
        },
    // =============================================================================
    // FULL PAGE LAYOUTS
    // =============================================================================
        {
            path: '',
            component: () => import('@/layouts/full-page/FullPage.vue'),
            children: [
        // =============================================================================
        // PAGES
        // =============================================================================
              {
                path: '/login',
                name: 'page-login',
                component: () => import('@/views/pages/Login.vue')
              },
              {
                path: '/pages/error-404',
                name: 'page-error-404',
                component: () => import('@/views/pages/Error404.vue')
              },
            ]
        },
        // Redirect to 404 page, if no match found
        {
            path: '*',
            redirect: '/pages/error-404'
        }
    ],
})


router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (store.getters.isLoggedIn) {
      next()
      return
    }
    next('/login')
  } else {
    next()
  }
})

router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById('loading-bg')
    if (appLoading) {
        appLoading.style.display = "none";
    }
})

export default router
